import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientCompanyBranchAvailableToAllocateSummaryProps<T> = {
  companyBranchId?: string
  filters?: {
    search?: string
    page?: number
    productCategoryId?: string
  }
  mapper?: (data: any) => T
}

export const useClientCompanyBranchAvailableToAllocateSummary = <T,>({
  companyBranchId,
  filters: { search = '', page, productCategoryId } = {},
  mapper = Mapper.default<T>(),
}: UseClientCompanyBranchAvailableToAllocateSummaryProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    enabled: !!companyBranchId,
    queryKey: ['clientCompanyBranchAvailableToAllocateSummary', companyBranchId, search, page, productCategoryId],
    queryFn: () => {
      return privateAxios.get(`/client/company_branches/${companyBranchId}/available_to_allocate_summary`, {
        params: {
          search,
          page,
          product_category_id: productCategoryId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
